import UsersManagement from './UsersManagement.container';

export default UsersManagement;
